import '../../../stylesheets/nav/profile-popover.css'

const SubscriptionSectionHeader = ( { toggleClose } ) => {
    return (
        <>
            {/* [Header Section]: Close button (top-right) */}
            <div className="subscription-modal-header">
                <button
                    className="subscription-modal-close"
                    onClick={toggleClose}
                    aria-label="Close subscription details"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ transform: 'scaleX(-1)' }}>
                        <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </>        
    )
}

export default SubscriptionSectionHeader